import { render } from "./LaboralComponent.vue?vue&type=template&id=68dd6324"
import script from "./LaboralComponent.vue?vue&type=script&lang=js"
export * from "./LaboralComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__